import { OnEventDispatcher } from "../core/on-event-dispatcher";
import { GoogleMaps, MarkerGroup } from "../core/googlemaps";
import { Receptions } from "../io/receptions";
import { Application } from "../main";
import { VaxiluskernaMap } from "./vaxiluskernamap";

const VaxiluskernaIconProps = {
    srcWidth: 62,
    srcHeight: 76,
    displayWidth: 31,
    displayHeight: 38
}
export type VaxiluskernaMarkerOptions = {
    icon: {
        idle: string,
        highlight: string,
        peripheral: string,
        tiny: string,
        tinyperipheral: string
    },
    title: string,
    position:{lat:number, lng:number},
    group:string

}
export class VaxiluskernaMarker extends OnEventDispatcher {
    
    map: VaxiluskernaMap;
    options: VaxiluskernaMarkerOptions;

    idleSymbol:google.maps.Icon;
    highlightSymbol:google.maps.Icon;
    marker: google.maps.Marker;
    selected: boolean = false;
    hovered: boolean;
    _opacity:number = 1;
    markerGroup: MarkerGroup;
    //isClustered:boolean;
    hidden:boolean = false;
    peripheral:boolean = false;
    peripheralSymbol: { url: string; size: google.maps.Size; origin: google.maps.Point; anchor: google.maps.Point; scaledSize: google.maps.Size; };
    isWithinBounds: boolean;
    tinySymbol: { url: any; size: google.maps.Size; origin: google.maps.Point; anchor: google.maps.Point; scaledSize: google.maps.Size; };
    tinyPeripheralSymbol: { url: any; size: google.maps.Size; origin: google.maps.Point; anchor: google.maps.Point; scaledSize: google.maps.Size; };

    constructor(map:VaxiluskernaMap, options:VaxiluskernaMarkerOptions) {
        
        super();
        this.map = map;
        this.options = options;

        this.idleSymbol = {
            url: this.options.icon.idle,
            size: new google.maps.Size(VaxiluskernaIconProps.srcWidth, VaxiluskernaIconProps.srcHeight),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(Math.round(VaxiluskernaIconProps.displayWidth/2), VaxiluskernaIconProps.displayHeight),
            scaledSize: new google.maps.Size(VaxiluskernaIconProps.displayWidth, VaxiluskernaIconProps.displayHeight)
        }
        this.peripheralSymbol = {
            url: this.options.icon.peripheral,
            size: new google.maps.Size(VaxiluskernaIconProps.srcWidth, VaxiluskernaIconProps.srcHeight),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(Math.round(VaxiluskernaIconProps.displayWidth/2), VaxiluskernaIconProps.displayHeight),
            scaledSize: new google.maps.Size(VaxiluskernaIconProps.displayWidth, VaxiluskernaIconProps.displayHeight)
        }
        this.highlightSymbol = {
            url: this.options.icon.highlight,
            size: new google.maps.Size(VaxiluskernaIconProps.srcWidth, VaxiluskernaIconProps.srcHeight),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(Math.round(VaxiluskernaIconProps.displayWidth/2), VaxiluskernaIconProps.displayHeight),
            scaledSize: new google.maps.Size(VaxiluskernaIconProps.displayWidth, VaxiluskernaIconProps.displayHeight)
        }

        this.tinySymbol = {
            url: this.options.icon.tiny,
            size: new google.maps.Size(VaxiluskernaIconProps.srcWidth, VaxiluskernaIconProps.srcHeight),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(Math.round(VaxiluskernaIconProps.displayWidth/2), VaxiluskernaIconProps.displayHeight),
            scaledSize: new google.maps.Size(VaxiluskernaIconProps.displayWidth, VaxiluskernaIconProps.displayHeight)
        }
        this.tinyPeripheralSymbol = {
            url: this.options.icon.tinyperipheral,
            size: new google.maps.Size(VaxiluskernaIconProps.srcWidth, VaxiluskernaIconProps.srcHeight),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(Math.round(VaxiluskernaIconProps.displayWidth/2), VaxiluskernaIconProps.displayHeight),
            scaledSize: new google.maps.Size(VaxiluskernaIconProps.displayWidth, VaxiluskernaIconProps.displayHeight)
        }
        
        
        this.marker = this.map.googlemaps.addMarker({
            position: this.options.position,
            title: null,//this.options.title,
            draggable: false,
            icon: this.idleSymbol,
            opacity: 1,
            zIndex: 0
        }, this.options.group);

        this.markerGroup = this.map.googlemaps.markerGroups[this.options.group];
        //this.markerGroup.markers.push(this.marker);
        //this.markerGroup.clusterer.addMarker(this.marker);
        //this.isClustered = false;

        this.marker.addListener("mouseover", () => {
            this.hovered = true;
            this.map.showTooltip(this.options.title);
            this.updateIcon();
        });
        this.marker.addListener("mouseout", () => {
            this.hovered = false;
            this.map.hideTooltip();
            this.updateIcon();
        });
        this.marker.addListener("click", () => {
            this.dispatch("click");
        });

        this.updateIcon();
    }

    updateIcon() {
        if(this.selected) {
            this.marker.setIcon(this.highlightSymbol);
            this.marker.setZIndex(10);
        } else {
            if(Receptions.visibleMarkerCount>80) {
                if(this.peripheral) {
                    this.marker.setIcon(this.tinyPeripheralSymbol);
                    this.marker.setZIndex(0);
                } else {
                    if(Application.receptionSearchResultCount==0) {
                        this.marker.setIcon(this.tinySymbol);
                        this.marker.setZIndex(1);
                    } else {
                        if(this.hovered) {
                            this.marker.setIcon(this.highlightSymbol);
                            this.marker.setZIndex(9);
                        } else {
                            this.marker.setIcon(this.idleSymbol);
                            this.marker.setZIndex(2);
                        }
                    }
                }
            } else {
                if(this.peripheral) {
                    this.marker.setIcon(this.peripheralSymbol);
                    this.marker.setZIndex(0);
                } else {
                    if(this.hovered) {
                        this.marker.setIcon(this.highlightSymbol);
                        this.marker.setZIndex(9);
                    } else {
                        this.marker.setIcon(this.idleSymbol);
                        this.marker.setZIndex(2);
                    }
                }
            }
        }
    }

    onMapBounds(mapBounds: google.maps.LatLngBounds) {
        this.isWithinBounds = mapBounds.contains(this.options.position);
    }

    setPeripheral(peripheral:boolean) {
        this.peripheral = peripheral;
        this.updateIcon();
    }
    setSelected(selected:boolean) {
        this.selected = selected;
        this.updateIcon();
    }

    setHide(hidden:boolean) {
        if(hidden&&!this.hidden) {
            this.hidden = true;
            this.marker.setMap(null);
        } else if(!hidden&&this.hidden) {
            this.hidden = false;
            this.marker.setMap(this.map.googlemaps.map);
        }
    }
}